<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">Handover</p>
      </div>

      <div class="flex flex-wrap justify-end w-full gap-3 p-2" >
        <div
            @click="showHandover = true"
            class="bg-primary flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
        >
          <img class="h-5" src="@/assets/icons/plus-small.svg" />
          <p>Create </p>
        </div>
        <div
            @click="showHandover = true"
            class="bg-green-500 flex text-white items-center text-sm px-3 py-1 rounded-md cursor-pointer"
        >
          <p>Complete Offboarding</p>
        </div>
      </div>

      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>

          <ve-table
              :columns="handoverColumns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
            style="min-height: 100%"
          >
          </ve-table>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
           No Handover Items Found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <div class="bg-white mt-3 mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">Separations</p>
      </div>

      <div class="flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="pageSizes"
              :page-index="pageIndex"
              :page-size="pageSize"
              layout="sizes"
              :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
              v-model="searchInput"
              type="search"
              placeholder="Start typing to search..."
              class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <div >
          <div class="flex flex-wrap justify-end w-full gap-3" >
            <div
                @click="showCreateSeparation = true"
                class="bg-primary flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
            >
              <img class="h-5" src="@/assets/icons/plus-small.svg" />
              <p>Create </p>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
              v-if="del_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
              v-if="showLocCrSuccess"
              class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
              v-if="showLocDelSuccess"
              class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>
          <ve-table
              style="min-height: 100%"
              v-if="searchInput"
              :columns="columns"
              :table-data="filteredTableData"
              sort-order="asc"
          />

          <ve-table
              :columns="columns"
              :tableData="currentTableData"
              v-if="!searchInput.length"
              style="min-height: 100%"
          >
          </ve-table>

          <p
              v-if="searchInput.length && filteredTableData.length === 0"
              class="text-center py-3"
          >
            No results
          </p>

          <p
              v-if="tableData.length == 0 && !loading && !get_error"
              class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Separation Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
              v-if="get_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateSeparation
      :close="handleClose"
      :showCreateSeparation="showCreateSeparation"
      @closeOnSuccess="handleCloseOnSuccess"
    ></CreateSeparation>

    <!-- edit -->
    <EditSeparationType
      @close="handleClose"
      :SeparationTypeToEdit="SeparationTypeToEdit"
      :info="SeparationTypeToEdit"
      :showEditSeparationType="showEditSeparationType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditSeparationType>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>

    <attachments-viewer
      :showAttachments="showAttachments"
      :attachmentUrl="attachmentUrl"
      :attachmentType="attachmentType"
      @close="showAttachments = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :docTitle="docTitle"
    ></attachments-viewer>
    <handover
        :showHandover="showHandover"
        @close="showHandover=false"
    >
    </handover>
  </div>
</template>

<script>
import axios from "axios";
import CreateSeparation from "./createSeparation.vue";
import EditSeparationType from "@/components/CompanySetups/separation/editSeparationType.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import DocumentsDisplayVue from "@/utils/documentsDisplay.vue";
import AttachmentsViewer from "@/utils/attachmentsViewer.vue";
import mergePDFs from "@/utils/createPdfBlob";
import Handover from "@/components/employees/modals/handover";
// import Switches from 'vue-switches';

export default {
  name: "SeparationTypeList",
  components: {
    Handover,
    Loader,
    CreateSeparation,
    EditSeparationType,
    ActionWarning,
    AttachmentsViewer,
  },
  data() {
    return {
      showCreateSeparation: false,
      showEditSeparationType: false,
      showHandover:false,
      showResign:false,
      loading: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      SeparationTypeToDelete: null,
      showWarning: false,
      SeparationTypeToEdit: {},
      showAttachments: false,
      attachmentUrl: "",
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Type",
          key: "a",
          title: "Type",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Reason",
          key: "b",
          title: "Reason",
          headerAlign: "center",
          align: "left",
        },

        {
          field: "Attachment",
          key: "Attachment",
          title: "Attachment",
          headerAlign: "center",
          align: "center",
          width: 200,
          renderBodyCell: ({ row }) => {
            return (
              <DocumentsDisplayVue
                delete-document-callback={this.deleteDocument}
                document={{
                  url: row.Attachment,
                  DocumentType: "Document",
                  documentId: row.EmployeeSeparationId,
                }}
                openPDFViewer={this.openPDFViewer}
                class="bg-white"
              ></DocumentsDisplayVue>
            );
          },
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => {
            if (this.getUserType.toLowerCase() !== "hr manager") {
              return null;
            }
            return (
                <ve-popper
                    trigger="clickToOpen"
                    options={{
                      placement: "top",
                      modifiers: {offset: {offset: "0,10px"}},
                    }}
                >
                  <div class="bg-white p-2 shadow-md popper">
                    <button
                        className="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                        style="boder-radius: 0 !important"
                        onClick={() => this.handleEditButtonClick(row)}
                    >
                      Edit
                    </button>
                    <button
                        className="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                        style="boder-radius: 0 !important"
                        onClick={() => this.handleDeleteButtonClick(row)}
                    >
                      Delete
                    </button>
                  </div>

                  <button slot="reference">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Outline"
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                    >
                      <circle cx="12" cy="2" r="2"/>
                      <circle cx="12" cy="12" r="2"/>
                      <circle cx="12" cy="22" r="2"/>
                    </svg>
                  </button>
                </ve-popper>
            )
          }
        },
      ],
      handoverColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Item",
          key: "a",
          title: "Item",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Collector",
          key: "b",
          title: "Collector",
          headerAlign: "center",
          align: "left",
        },
        {
          field: "Due Date",
          key: "b",
          title: "Due Date",
          headerAlign: "center",
          align: "left",
        },
        {
          field: "Status",
          key: "b",
          title: "Status",
          headerAlign: "center",
          align: "left",
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => {
            if (this.getUserType.toLowerCase() !== "hr manager") {
              return null;
            }
            return (
                <ve-popper
                    trigger="clickToOpen"
                    options={{
                      placement: "top",
                      modifiers: {offset: {offset: "0,10px"}},
                    }}
                >
                  <div class="bg-white p-2 shadow-md popper">
                    <button
                        className="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                        style="boder-radius: 0 !important"
                        onClick={() => this.handleEditButtonClick(row)}
                    >
                      Collected
                    </button>
                    <button
                        className="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                        style="boder-radius: 0 !important"
                        onClick={() => this.handleDeleteButtonClick(row)}
                    >
                      Delete
                    </button>
                  </div>

                  <button slot="reference">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Outline"
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                    >
                      <circle cx="12" cy="2" r="2"/>
                      <circle cx="12" cy="12" r="2"/>
                      <circle cx="12" cy="22" r="2"/>
                    </svg>
                  </button>
                </ve-popper>
            )
          }
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId", "getUserType"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getSeparations();
    this.setPageSizes();
  },
  methods: {
    openPDFViewer(documentUrl, title) {
      this.loading = true;
      const config = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        responseType: "arraybuffer",
      };

      this.attachmentType = documentUrl;
      this.docTitle = title;

      axios
        .get(documentUrl, config)
        .then(async (response) => {
          this.loading = false;

          const contentDisposition = response.headers["content-disposition"];
          // console.log(response);
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

            if (fileNameMatch && fileNameMatch[1]) {
              const originalFileName = fileNameMatch[1];
              console.log("Original file name:", originalFileName);
            }
          }
          // Check if the response data is a valid PDF
          if (response.headers["content-type"] === "application/pdf") {
            // Create a URL for the Blob
            const url = await mergePDFs(response.data);

            // Set the PDF URL to attachmentUrl
            this.attachmentUrl = url;
            // alert(url);
          } else {
            // If it's not a valid PDF, it is treated as an image
            const blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            const url = URL.createObjectURL(blob);

            // Set the image URL to attachmentUrl
            this.attachmentUrl = url;
          }

          this.showAttachments = true;
        })
        .catch((error) => {
          this.loading = false;
          this.get_error = error;
          setTimeout(() => {
            this.get_error = null;
          }, 2500);
        });
    },
    // /{organization}/employee/document/{employeeDocumentId}/v1/delete
    deleteDocument(employeeDocumentId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/employee/document/${employeeDocumentId}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;

              setTimeout(() => {
                this.del_success = null;
                this.reload();
              }, 2500);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateSeparation = false;
      this.showEditSeparationType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateSeparation = false;
      this.showLocCrSuccess = false;
      this.showEditSeparationType = false;
      this.showAttachments = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getSeparations();
    },

    reload() {
      this.getDepartments();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteSeparationType(this.SeparationTypeToDelete);
    },

    handleEditButtonClick(separationType) {
      // Handle the button click for the edit button

      this.SeparationTypeToEdit = separationType;
      this.showEditSeparationType = true;
    },
    handleDeleteButtonClick(SeparationType) {
      // Handle the button click for the delete button
      //console.log(SeparationType)
      this.title = `Delete ${SeparationType.Name}`;
      this.message = `You are about to delete ${SeparationType.Name}!`;
      this.SeparationTypeToDelete = SeparationType;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getSeparations();
    },
    getSeparations() {
      this.loading = true;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params: {
          employeeId: this.getCurrentEmployeeId,
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/separation/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.tableData = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    deleteSeparationType(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          SeparationTypeId: row.EmployeeSeparationId,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/separation/type/v1/delete/`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },

    editSeparationType(row) {
      this.showEditSeparationType = true;
      this.info = row;
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
